module.exports = {
    BUCKET_IMAGES_URL: "https://s3.amazonaws.com/ui.healthnote.com/images",
};